import { styled, Box, Stack } from '@mui/material'

import { COLORS, serratedEdgeHorizontalCss, unit } from '@hcr/ui'

export const LayoutTicketDetailsInactiveContainer = styled(Box)`
  overflow-x: clip;
`

export const LayoutTicketDetailsInactiveContent = styled(Stack)`
  padding: ${unit(24)} ${unit(7)} ${unit(7.5)};
  background-color: ${COLORS.white};

  ${serratedEdgeHorizontalCss}
`

export const LayoutTicketDetailsInactiveHeader = styled(Stack)`
  gap: ${unit(8.5)};
  padding-bottom: ${unit(8.5)};
`

export const LayoutTicketDetailsInactiveName = styled(Box)`
  display: flex;
  justify-content: space-between;
  gap: ${unit(2)};
`

export const LayoutTicketDetailsInactiveFooter = styled(Stack)`
  gap: ${unit(5)};
  padding: ${unit(5)} ${unit(7)};
`
